var s_today = new Date();
var e_today = new Date();


var s_yesterday = new Date();
var e_yesterday = new Date();
s_yesterday.setDate(s_yesterday.getDate() - 1);
e_yesterday.setDate(e_yesterday.getDate() - 1);

var s_lastWeek = new Date();
var e_lastWeek = new Date();
s_lastWeek.setDate(s_lastWeek.getDate() - 6);

var s_currentMonth = new Date();
s_currentMonth.setDate(1);

var s_lastMonth = new Date();
var e_lastMonth = new Date();
s_lastMonth.setDate(1);
s_lastMonth.setMonth(s_lastMonth.getMonth() - 1);
e_lastMonth.setDate(1);
e_lastMonth.setDate(e_lastMonth.getDate() - 1);

var s_lastThreeMonth = new Date();
var e_lastThreeMonth = new Date();
s_lastThreeMonth.setDate(1);
s_lastThreeMonth.setMonth(s_lastThreeMonth.getMonth() - 3);
e_lastThreeMonth.setDate(1);
e_lastThreeMonth.setDate(e_lastThreeMonth.getDate() - 1);

var s_lastSixMonth = new Date();
var e_lastSixMonth = new Date();
s_lastSixMonth.setDate(1);
s_lastSixMonth.setMonth(s_lastSixMonth.getMonth() - 6);
e_lastSixMonth.setDate(1);
e_lastSixMonth.setDate(e_lastSixMonth.getDate() - 1);

var s_lastYear = new Date();
var e_lastYear = new Date();
s_lastYear.setFullYear(s_lastYear.getFullYear() - 1);

var s_lastTwoYear = new Date();
var e_lastTwoYear = new Date();
s_lastTwoYear.setFullYear(s_lastTwoYear.getFullYear() - 2);

const Periods = {
  today: [s_today, e_today],
  yesterday: [s_yesterday, e_yesterday],
  lastWeek: [s_lastWeek, e_lastWeek],
  currentMonth: [s_currentMonth, e_today],
  lastMonth: [s_lastMonth, e_lastMonth],
  lastThreeMonth: [s_lastThreeMonth, e_lastThreeMonth],
  lastSixMonth: [s_lastSixMonth, e_lastSixMonth],
  lastYear: [s_lastYear, e_lastYear],
  lastTwoYear: [s_lastTwoYear, e_lastTwoYear]
}

export default Periods;